class SizeGuideDrawer extends HTMLElement {
  constructor() {
    super();
    this._onKeyUp = this._onKeyUp.bind(this);
    this._onBackdropClick = this._onBackdropClick.bind(this);
    this._trigger = null;
  }

  connectedCallback() {
    // Close when clicking the backdrop (the drawer element itself, outside the inner panel)
    this.addEventListener('click', this._onBackdropClick);

    this.querySelector('.size-guide-drawer__close')
      ?.addEventListener('click', () => this.close());

    this.querySelectorAll('.size-guide-drawer__unit-btn').forEach((btn) => {
      btn.addEventListener('click', () => this._setUnit(btn.dataset.unit));
    });

    this._registerTrigger();
  }

  _registerTrigger() {
    const trigger = document.querySelector(`[aria-controls="${this.id}"]`);
    if (!trigger) return;
    this._trigger = trigger;
    trigger.addEventListener('click', () => this.open());
  }

  open() {
    this.classList.add('active');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keyup', this._onKeyUp);

    if (this._trigger) this._trigger.setAttribute('aria-expanded', 'true');

    const inner = this.querySelector('.size-guide-drawer__inner');
    const closeBtn = this.querySelector('.size-guide-drawer__close');
    if (inner && typeof trapFocus === 'function') {
      setTimeout(() => trapFocus(inner, closeBtn), 50);
    } else if (closeBtn) {
      setTimeout(() => closeBtn.focus(), 50);
    }
  }

  close() {
    this.classList.remove('active');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keyup', this._onKeyUp);

    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(this._trigger);
    } else if (this._trigger) {
      this._trigger.focus();
    }

    if (this._trigger) this._trigger.setAttribute('aria-expanded', 'false');
  }

  _onKeyUp(event) {
    if (event.code === 'Escape') this.close();
  }

  _onBackdropClick(event) {
    // Only close when the click lands outside the inner panel
    if (!event.target.closest('.size-guide-drawer__inner')) {
      this.close();
    }
  }

  _setUnit(unit) {
    this.querySelectorAll('.size-guide-drawer__unit-btn').forEach((btn) => {
      btn.classList.toggle('is-active', btn.dataset.unit === unit);
    });

    this.querySelectorAll('td[data-cm]').forEach((cell) => {
      const raw = cell.dataset.cm;
      if (raw === '' || raw == null) return;
      const cm = parseFloat(raw);
      if (isNaN(cm)) return;
      cell.textContent = unit === 'in' ? (cm / 2.54).toFixed(1) : raw;
    });
  }
}

if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}
